export default "{\n    \"suspended\": \"Suspended\"\n}\n"